import { MODULE_NAME as TRACKING_MODULE } from 'modules/tracking/config/routes';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { ACTIVE_EVENTS_REPORT_ID } from './activeEventsReportId';
import columnDefinitions from './columnDefinitions';
import { customColumns, defaultColumns } from './reportPresets';

export const activeEventsTrackingReportConfig = {
    id: ACTIVE_EVENTS_REPORT_ID,
    label: 'Active Events',
    permissions: ['TA_ACTIVE_EVENTS_REPORT'],
    module: TRACKING_MODULE,
    endpoint: 'active-events',
    rowIdField: FIELDS.EVENT_NAME.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    searchPlaceholderMsgId: 'tracking.active.events.report.search.placeholder',
    searchField: FIELDS.EVENT_NAME.field,
    filters: [
        //TODO - DEV 129744
        // {
        //     id: FILTER_TYPE.DEFINED_CONVERSIONS,
        // },
        // {
        //     id: FILTER_TYPE.EVENT_NAME,
        // },
    ],
    initialFilters: [],
};

export default activeEventsTrackingReportConfig;
